import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { ResourcesService } from '@sh/resources/services/resources.service';
import { ICategory } from '@sh/resources/interfaces/i-category';

@Component({
  selector: 'app-explore-subjects',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './explore-subjects.component.html',
  styleUrls: ['./explore-subjects.component.scss'],
})
export class ExploreSubjectsComponent implements OnInit {
  private resources = inject(ResourcesService);
  private destroyRef = inject(DestroyRef);
  private platform = inject(PLATFORM_ID);
  subjects: ICategory[] = [];
  expanded = false;
  readonly suggestions = [
    'Science',
    'Maths',
    'Social studies',
    'Languages',
    'ICT & technology',
    'Arts',
    'Health & PE',
  ].map((name) => ({ id: '', name }));
  get visibleSubjects() {
    const subjects = this.subjects.length ? this.subjects : this.suggestions;
    return this.expanded ? subjects : subjects.slice(0, 7);
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platform))
      this.resources
        .getCategories()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (r) => {
            this.subjects = r.data?.items ?? [];
          },
          error: () => {
            this.subjects = [];
          },
        });
  }
  icon(name: string) {
    const rules: [RegExp, string][] = [
      [/life science|biology|agricultur/i, 'life-sciences'],
      [/math|numeracy|account/i, 'maths'],
      [/science|chemistry|physics/i, 'science'],
      [/geograph|social/i, 'geography'],
      [
        /language|english|afrikaans|isizulu|isixhosa|sesotho|setswana|literacy/i,
        'languages',
      ],
      [/ict|comput|information tech/i, 'computing'],
      [/art|music|drama|design/i, 'arts'],
      [/health|physical edu|life orientation|sport/i, 'health'],
      [/business|economic/i, 'business'],
      [/history/i, 'history'],
      [/tech|engineering/i, 'technology'],
    ];
    return (
      '/assets/images/subjects/' +
      (rules.find(([pattern]) => pattern.test(name))?.[1] ?? 'subjects') +
      '.svg'
    );
  }
}
